import { useState } from "react";

// Define a type for search results
interface SearchResult {
  id: number;
  name: string;
}

// Hook for managing search logic
const useSearch = (initialQuery = "") => {
  const [query, setQuery] = useState(initialQuery);
  const [results, setResults] = useState<SearchResult[]>([]); // Specify the correct type here
  const [isSearching, setIsSearching] = useState(false);

  // Function to handle search query updates
  const handleSearch = async (searchTerm: string) => {
    setQuery(searchTerm);
    setIsSearching(true);

    // Replace with your search API or logic
    const searchResults: SearchResult[] = await mockSearchAPI(searchTerm); // Type the response

    setResults(searchResults);
    setIsSearching(false);
  };

  // Mock API search function (replace with actual API call)
  const mockSearchAPI = async (searchTerm: string): Promise<SearchResult[]> => {
    return new Promise((resolve) => {
      setTimeout(() => {
        // Mocked results
        resolve([
          { id: 1, name: `${searchTerm} 1` },
          { id: 2, name: `${searchTerm} 2` },
          { id: 3, name: `${searchTerm} 3` },
        ]);
      }, 500);
    });
  };

  return { query, setQuery, results, isSearching, handleSearch };
};

export default useSearch;
